import { render, staticRenderFns } from "./WallOfLoveSection.vue?vue&type=template&id=6048c6ae&scoped=true&"
import script from "./WallOfLoveSection.vue?vue&type=script&lang=js&"
export * from "./WallOfLoveSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048c6ae",
  null
  
)

export default component.exports